<div class="container">
    <ng-container *ngIf="isLoading; else loaded">
        <ngx-skeleton-loader
          count="5"
          [theme]="{ 
              'height.px': 50
          }"
        ></ngx-skeleton-loader>
    </ng-container>
    <ng-template #loaded>
        <mat-chip-set *ngIf="readOnly" [attr.aria-label]="'GoalFormStatus' | translate: {Default: 'Form status'}">
            <mat-chip class="green-chip" appLocalizationPopupDirective [localizationCode]="'EmployeeGoals-ReadOnly'">{{ 'EmployeeGoals-ReadOnly' | translate: {Default: "Read Only"} }}</mat-chip>
        </mat-chip-set>

        <div class="form">
            <div class="form-section" *ngIf="!hideGoalPlan">
                <div class="form-section-title">
                    <h3 class="form-section-heading" appLocalizationPopupDirective [localizationCode]="'EmployeeGoals-GoalPlan'">
                        {{ 'EmployeeGoals-GoalPlan' | translate: {Default: "Goal Plan"} }}
                    </h3>
                </div>
                <div class="form-section-contents">
                    <div class="section-row">
                        <form [formGroup]="goalForm">
                            <app-permissible-employee-goal-plans
                                [formElement]="{
                                    text: translate.instant('EmployeeGoals-GoalPlan'),
                                    formControl: 'goalPlan'
                                }"
                                [parentGroup]="goalForm"
                                [readOnly]="this.goalForm.get('goalPlan').disabled"
                            >
                            </app-permissible-employee-goal-plans>
                        </form>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-section-title">
                    <h3 class="form-section-heading" appLocalizationPopupDirective [localizationCode]="'EmployeeGoals-GoalDetails'">{{ 'EmployeeGoals-GoalDetails' | translate: {Default: "Goal Details"} }}</h3>
                </div>
                <div class="form-section-contents">
                    <div class="section-row">
                        <form [formGroup]="goalForm">
                            <mat-form-field appearance="fill">
                                <mat-label>
                                    {{ getColumnTitle('tfi_PEgObjective') }}
                                    <span class="sr-only" *ngIf="readOnly">{{ 'Read-only' | translate: {Default: 'Read-only'} }}</span>
                                </mat-label>
                    
                                <input 
                                    matInput 
                                    type="text"
                                    formControlName="objective"
                                    [attr.aria-disabled]="readOnly"
                                    [attr.aria-readonly]="readOnly"
                                >
                                <mat-icon *ngIf="readOnly" matSuffix class="material-icons-outlined disabled-field-icon" aria-hidden="false" [attr.aria-label]="'Read-only' | translate: {Default: 'Read-only'}">lock</mat-icon>
                            </mat-form-field>
                
                            <mat-form-field appearance="fill">
                                <mat-label>
                                    {{ getColumnTitle('tfi_PEgDescription') }}
                                    <span class="sr-only" *ngIf="readOnly">{{ 'Read-only' | translate: {Default: 'Read-only'} }}</span>
                                </mat-label>
                    
                                <textarea 
                                    matInput 
                                    cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    cdkAutosizeMaxRows="30"
                                    formControlName="description"
                                    [attr.aria-disabled]="readOnly"
                                    [attr.aria-readonly]="readOnly"
                                ></textarea>
                                <mat-icon *ngIf="readOnly" matSuffix class="material-icons-outlined disabled-field-icon" aria-hidden="false" [attr.aria-label]="'Read-only' | translate: {Default: 'Read-only'}">lock</mat-icon>
                            </mat-form-field>
                          </form>
                    </div>
                </div>
            </div>
            
            

            <div class="form-section">
                <div class="form-section-title">
                    <h3 class="form-section-heading" appLocalizationPopupDirective [localizationCode]="'EmployeeGoals-ProgressDetails'">{{ 'EmployeeGoals-ProgressDetails' | translate: {Default: "Progress Details"} }}</h3>
                </div>
                <div class="form-section-contents">
                    <div class="section-row">
                        <form [formGroup]="goalForm">
                            <mat-form-field  appearance="fill">
                                <mat-label>
                                    {{ getColumnTitle('tfi_PEgExpectedCompletionDate') }}
                                    <span class="sr-only" *ngIf="readOnly">{{ 'Read-only' | translate: {Default: 'Read-only'} }}</span>
                                </mat-label>
                    
                                <input matInput [matDatepicker]="expectedCompletionDatepicker" formControlName="expectedCompletionDate"
                                    [attr.aria-disabled]="readOnly"
                                    [attr.aria-readonly]="readOnly">
                                <span fxLayout="row" matSuffix>
                                    <mat-datepicker-toggle  [for]="expectedCompletionDatepicker"></mat-datepicker-toggle>
                                </span>
                                <mat-icon *ngIf="readOnly" matSuffix class="material-icons-outlined disabled-field-icon" aria-hidden="false" [attr.aria-label]="'Read-only' | translate: {Default: 'Read-only'}">lock</mat-icon>
                                <mat-datepicker #expectedCompletionDatepicker></mat-datepicker>
                            </mat-form-field>
                
                            <mat-form-field  appearance="fill">
                                <mat-label>
                                    {{ getColumnTitle('tfi_PEgActualCompletionDate') }}
                                    <span class="sr-only" *ngIf="readOnly">{{ 'Read-only' | translate: {Default: 'Read-only'} }}</span>
                                </mat-label>
                    
                                <input matInput [matDatepicker]="actualCompletionDatepicker" formControlName="actualCompletionDate"
                                    [attr.aria-disabled]="readOnly"
                                    [attr.aria-readonly]="readOnly">
                                <span fxLayout="row" matSuffix>
                                    <mat-datepicker-toggle  [for]="actualCompletionDatepicker"></mat-datepicker-toggle>
                                </span>
                                <mat-icon *ngIf="readOnly" matSuffix class="material-icons-outlined disabled-field-icon" aria-hidden="false" [attr.aria-label]="'Read-only' | translate: {Default: 'Read-only'}">lock</mat-icon>
                                <mat-datepicker #actualCompletionDatepicker></mat-datepicker>
                            </mat-form-field>
                
                            <div class="slider-container">
                                <div class="slider-label">
                                    {{ getColumnTitle('tfi_PEgPercentageComplete') }}
                                </div>
                                <div class="slider-input">
                                    <mat-form-field appearance="fill" class="invisible" aria-hidden="true">
                                        <input
                                            #modValue
                                            type="number"
                                            max="1"
                                            min="0"
                                            step="0.01"
                                            formControlName="percentageComplete"
                                            tabindex="-1"
                                            matInput>
                                    </mat-form-field>
                    
                                    <mat-form-field appearance="fill">
                                        <input
                                            type="number"
                                            [max]="100"
                                            [min]="0"
                                            [step]="1"
                                            [(value)]="percentageSliderValue"
                                            [readonly]="readOnly"
                                            (input)="setValue($event.target.value / 100, goalForm, 'percentageComplete'); calculateSliderPercentage($event.target.value / 100, 1)"
                                            matInput>
                                        <mat-icon class="material-icons-outlined" matSuffix aria-hidden="true">percent</mat-icon>
                                    </mat-form-field>

                                    <div class="slider">
                                        <mat-slider
                                            max="1"
                                            min="0"
                                            step="0.01"
                                            [(value)]="modValue.value"
                                            [disabled]="readOnly"
                                            (input)="setValue($event.value, goalForm, 'percentageComplete'); calculateSliderPercentage($event.value, 1)"
                                            [attr.aria-label]="getColumnTitle('tfi_PEgPercentageComplete')"
                                        >
                                        </mat-slider>
                                    </div>
                                </div>
                            </div>
                
                            <div class="slider-container">
                                <div class="slider-label">
                                    {{ getColumnTitle('tfi_PEgWeight') }}
                                </div>
                                <div class="slider-input">
                                    <mat-form-field appearance="fill" class="invisible" aria-hidden="true">
                                        <input
                                            #modValueWeight
                                            type="number"
                                            max="1"
                                            min="0"
                                            step="0.01"
                                            formControlName="weight"
                                            tabindex="-1"
                                            matInput>
                                    </mat-form-field>
                    
                                    <mat-form-field appearance="fill">
                                        <input
                                            type="number"
                                            [max]="100"
                                            [min]="0"
                                            [step]="1"
                                            [(value)]="weightSliderValue"
                                            [readonly]="readOnly"
                                            (input)="setValue($event.target.value / 100, goalForm, 'weight'); calculateWeightSliderPercentage($event.target.value / 100, 1)"
                                            matInput>
                                        <mat-icon class="material-icons-outlined" matSuffix>percent</mat-icon>
                                    </mat-form-field>
                    
                                    <div class="slider">
                                        <mat-slider
                                            max="1"
                                            min="0"
                                            step="0.01"
                                            [(value)]="modValueWeight.value"
                                            [disabled]="readOnly"
                                            (input)="setValue($event.value, goalForm, 'weight'); calculateWeightSliderPercentage($event.value, 1)"
                                            [attr.aria-label]="getColumnTitle('tfi_PEgWeight')"
                                        >
                                        </mat-slider>
                                    </div>
                                </div>
                            </div>

                            <div class="form-section" *ngIf="!hideGoalPlan">
                                <div class="form-section-title">
                                    <h3 class="form-section-heading">
                                        {{ getColumnTitle('tfi_PEgGoalType') }}
                                    </h3>
                                </div>
                                <div class="form-section-contents">
                                    <div class="section-row">
                                        <form [formGroup]="goalForm">
                                            <app-goal-type-selection-form-field
                                                [formElement]="{
                                                    text: getColumnTitle('tfi_PEgGoalType'),
                                                    formControl: 'goalTypeId'
                                                }"
                                                [parentGroup]="goalForm"
                                                [readOnly]="this.goalForm.get('goalTypeId').disabled"
                                                [mandatoryFilter]="mandatoryGoalTypeFilter"
                                            >
                                            </app-goal-type-selection-form-field>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            <div class="form-section" *ngIf="parentId && !isAParent">
                                <div class="form-section-title">
                                    <h3 class="form-section-heading">
                                        {{ getColumnTitle('tfi_PEgParentGoal') }}
                                    </h3>
                                </div>
                                <div class="form-section-contents">
                                    <div class="section-row">
                                        <form [formGroup]="goalForm">
                                            <app-goal-selection-form-field
                                                [formElement]="{
                                                    text: getColumnTitle('tfi_PEgParentGoal'),
                                                    formControl: 'parentId'
                                                }"
                                                [parentGroup]="goalForm"
                                                [readOnly]="this.goalForm.get('parentId').disabled"
                                                [mandatoryFilter]="mandatoryFilter"
                                            >
                                            </app-goal-selection-form-field>
                                        </form>
                                    </div>
                                </div>
                            </div>
                
                            
                        </form>
                    </div>
                </div>
            </div>

            <button 
                *ngIf="readOnly !== true"
                mat-raised-button 
                color="primary" 
                setColor="primaryColour"
                appPreventDoubleClick 
                (throttledClick)="save()" 
            >{{ 'Save' | translate: {Default: "Save"} }}</button>
        </div>
    </ng-template>
</div>
